var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"status"},[_c('v-tooltip',{attrs:{"color":_vm.color,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-progress-linear',_vm._g({attrs:{"color":_vm.color,"rounded":"","buffer-value":"100","value":"100"}},on))]}}],null,false,445367700)},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }